import { createAsyncThunk } from "@reduxjs/toolkit";
import axiosGet from "../axios/axios-get";
import axiosPost from "../axios/axios-post";

const BASE_URL = "/available-hours";

export const WeAreAvailableAPI = Object.freeze({
  get: createAsyncThunk(
    "get/we-are-available",
    async (params, { rejectWithValue }) => {
      try {
        const response = await axiosGet.get(BASE_URL, {
          params,
        });
        return response.data;
      } catch (err) {
        return rejectWithValue(
          err.response?.data?.message ?? err.response?.data ?? err.message
        );
      }
    }
  ),

  create: createAsyncThunk(
    "post/we-are-available",
    async (data, { rejectWithValue }) => {
      try {
        const response = await axiosPost.post(BASE_URL, data);
        return response.data;
      } catch (err) {
        return rejectWithValue("Something went wrong");
      }
    }
  ),
});
